import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import { useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import publicProfileLogo from '../../../assets/images/Profile/public_prof_logo.png';
import { formatBytes } from '../../../../Hooks/bytesToMB';
import useClickOutside from '../../../../Hooks/useClickOutside';
import { PreviewModal } from './PreviewModal/PreviewModal';
export interface IProfileSettingsProps {
}

export function ProfileSettings(props: IProfileSettingsProps) {



    // Drag and drop functionality------------------
    const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
        accept: 'image/gif,image/png,image/webp,video/mp4,video/mp3',
        maxSize: 100000000,
    });
    const files = acceptedFiles.map((file: any) => (
        <span
            className="text-cusBlueWhite"
            key={file.path}>
            {file.path} - {formatBytes(file.size)}
        </span>
    ));
    const files2 = acceptedFiles.map((file: any) => (
        <span
            className="text-cusBlueWhite"
            key={file.path}>
            {file.path} - {formatBytes(file.size)}
        </span>
    ));





    // ---------------------Preview BTN---------------------
    const [showPreview, setShowPreview] = useState(false)
    const previewRef = useRef(null);
    useClickOutside(previewRef, () => setShowPreview(false))










    return (
        <div className="text-left mt-8 profile_Settings_min_box">

            <div className="flex justify-between items-start sm:items-center">
                <div className="text-left">
                    <h1 className="text-xl sm:text-2xl xl:text-3xl font-extrabold text-cusBlack dark:text-white">Profile Settings</h1>
                    <p className="xs:text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2 w-10/12 lg:w-full">You can set preferred display name, create your branded profile URL and manage other personal settings</p>
                </div>
                <div className="preview_btn_box inline-block">
                    <button
                        onClick={() => setShowPreview(!showPreview)}
                        className="bg-white dark:bg-cusBlack
                        px-2 py-2 lg:px-4 lg:py-2.5 xl:px-5 xl:py-3.5
                        rounded-md text-cusBlack dark:text-white flex justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG w-4 sm:w-auto" width="21.899" height="12.629" viewBox="0 0 21.899 12.629">
                            <g id="visible-opened-eye-interface-option" transform="translate(0 -20.843)">
                                <path id="Path_1166" data-name="Path 1166" d="M21.615,26.39c-.192-.227-4.789-5.547-10.666-5.547S.477,26.163.284,26.39a1.18,1.18,0,0,0,0,1.535c.193.227,4.789,5.547,10.666,5.547s10.473-5.32,10.666-5.547A1.18,1.18,0,0,0,21.615,26.39Zm-8.871-2.351a1.116,1.116,0,0,1,1.03,1.887,1.116,1.116,0,0,1-1.03-1.887ZM10.95,31.545c-4.1,0-7.559-3.153-8.755-4.387A16.432,16.432,0,0,1,7.213,23.6a4.471,4.471,0,1,0,7.474,0A16.434,16.434,0,0,1,19.7,27.158C18.509,28.393,15.055,31.545,10.95,31.545Z" transform="translate(0)" fill="#fff" />
                            </g>
                        </svg>
                        <p className="ml-3 text-xs sm:text-base">Preview</p>
                    </button>
                </div>
            </div>


            <AnimatePresence>
                {showPreview &&
                    <PreviewModal
                        showPreview={showPreview}
                        setShowPreview={setShowPreview}
                        previewRef={previewRef}
                    />
                }
            </AnimatePresence>




            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 2xl:grid-cols-3">
                <div className="lg:col-span-3 xl:col-span-2 2xl:col-span-1 xs:order-2 md:order-1 xs:mt-6 md:mt-0">
                    <div className="">
                        <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Display name</h4>
                        <input type="text" name="" id="" placeholder='Enter Username'
                            className="lightBlueBg p-5 rounded-xl mt-3 relative bg-transparent form-input transition-all w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                    </div>
                    <div className="mt-6">
                        <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Bio</h4>
                        <textarea name="" id="" cols={30} rows={4} placeholder='Tell the world your story!'
                            className="lightBlueBg form-textarea rounded-xl mt-2 relative thinScrollBar bg-transparent w-full h-full outline-none text-cusBlack dark:text-white p-5"
                        ></textarea>
                    </div>
                    <div className="mt-6">
                        <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Email Address</h4>
                        <input type="email" name="" id="" placeholder='Enter Email'
                            className="form-input lightBlueBg p-5 rounded-xl transition-all mt-3 relative bg-transparent w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                    </div>

                    <div className="mt-6">
                        <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Twitter Username</h4>
                        <p className="text-l-LightBlack text-sm dark:text-[#8987AF] mt-2">Link your Twitter account to gain more trust on the marketplace</p>

                        <div className="relative">
                            <input type="email" name="" id="" placeholder='Enter twitter username' defaultValue="@"
                                className="lightBlueBg p-5 rounded-xl mt-2 form-input transition-all bg-transparent w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                            <div className="absolute top-4 right-2 bg-[#EFEFEF] dark:bg-[#423D85] p-2 rounded flex justify-center items-center">
                                <p className="text-l-LightBlack dark:text-[#6F6DAB] mr-2 text-xl font-black">Link</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22.464" height="18.252" viewBox="0 0 22.464 18.252">
                                    <path id="twitter" d="M22.464,50.161a9.6,9.6,0,0,1-2.654.727,4.579,4.579,0,0,0,2.026-2.545,9.2,9.2,0,0,1-2.92,1.115,4.6,4.6,0,0,0-7.966,3.149,4.742,4.742,0,0,0,.107,1.05A13.035,13.035,0,0,1,1.564,48.84a4.607,4.607,0,0,0,1.415,6.155A4.548,4.548,0,0,1,.9,54.428v.051A4.626,4.626,0,0,0,4.588,59a4.6,4.6,0,0,1-1.207.152,4.071,4.071,0,0,1-.872-.079,4.649,4.649,0,0,0,4.3,3.208A9.253,9.253,0,0,1,1.1,64.249,8.624,8.624,0,0,1,0,64.185a12.965,12.965,0,0,0,7.065,2.067,13.017,13.017,0,0,0,13.108-13.1c0-.2-.007-.4-.017-.6A9.187,9.187,0,0,0,22.464,50.161Z" transform="translate(0 -48)" fill="#6f6dab" />
                                </svg>
                            </div>

                        </div>
                    </div>
                    <div className="mt-6">
                        <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Personal site or portfolio</h4>
                        <input type="email" name="" id="" placeholder='https://'
                            className="lightBlueBg p-5 rounded-xl mt-3 relative form-input transition-all bg-transparent w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                    </div>


                    <div className="add_more_btn_box mt-6">
                        <button className="lightBlueBg py-3 w-full rounded-lg add_more_btn text-cusBlack dark:text-white">
                            + Add Link
                        </button>
                    </div>

                    {/* <div className="mt-8">
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Linked wallet</h4>
                        <div className="mt-3 lightBlueBg xs:p-2 sm:p-3 rounded-xl flex justify-between items-center">
                            <div className="flex justify-start items-center">
                                <div className="ethereum xs:w-8 xs:h-8 sm:w-10 sm:h-10 flex justify-center items-center rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-3 sm:w-auto" width="16.398" height="26.235" viewBox="0 0 16.398 26.235">
                                        <g id="Group_1488" data-name="Group 1488" transform="translate(0 0)">
                                            <path id="Path" d="M632.2,207.1v9.7l8.2,3.663Z" transform="translate(-624.003 -207.1)" fill="rgba(255,255,255,0.6)" />
                                            <path id="Path_1_" d="M469,207.1l-8.2,13.361L469,216.8Z" transform="translate(-460.8 -207.1)" fill="#fff" />
                                            <path id="Path_2_" d="M632.2,523.158v6.59l8.2-11.348Z" transform="translate(-624.003 -503.513)" fill="rgba(255,255,255,0.6)" />
                                            <path id="Path_3_" d="M469,529.748v-6.59l-8.2-4.758Z" transform="translate(-460.8 -503.513)" fill="#fff" />
                                            <path id="Path_4_" d="M632.2,418.321l8.2-4.758-8.2-3.663Z" transform="translate(-624.003 -400.202)" fill="rgba(255,255,255,0.2)" />
                                            <path id="Path_5_" d="M460.8,413.563l8.2,4.758V409.9Z" transform="translate(-460.8 -400.202)" fill="rgba(255,255,255,0.6)" />
                                        </g>
                                    </svg>
                                </div>
                                <div className="ml-3 ">
                                    <h4 className="xs:text-xxs lg:text-base text-cusBlack dark:text-white">0x133C94D....6F2e8</h4>
                                    <p className="xs:text-xxs sm:text-xs text-cusBlack dark:text-cusBlueWhite mt-1">Ethereum</p>
                                </div>
                            </div>

                            <button className="linked_wallet_btn xs:px-3 sm:px-6 rounded-md xs:py-1 sm:py-2 text-white text-xs lg:text-sm">
                                Connected
                            </button>
                        </div>
                    </div> */}
                    <button className="xs:text-sm md:text-lg font-semibold text-white mt-5 xs:p-4 sm:p-4 2xl:p-6 w-full rounded-xl  gradientBtn">
                        Update Profile
                    </button>
                </div>





                <div className="lg:col-span-2 xl:col-span-3 2xl:col-span-2 md:pl-10 lg:pl-20 xs:order-1 md:order-2">
                    <div className="text-left w-full xl:w-6/12 2xl:w-5/12 3xl:w-4/12">
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Profile Avatar</h4>


                        <div>
                            <div {...getRootProps({ className: 'logoImageDropdown inline-block mt-6' })}>
                                <input {...getInputProps()} />
                                <div className="bg-[#ffffff] dark:bg-[#0E0631] border-2 border-dashed border-[#D8D8D8] dark:border-[#3d3892] rounded-full w-28 h-28 lg:w-36 lg:h-36 overflow-hidden flex justify-center items-center">

                                    <button
                                        className="font-semibold dark:font-medium bg-cusBrightLink dark:bg-black text-cusLightLink
                                         dark:text-cusLink xs:px-3 lg:px-4 xs:py-1 lg:py-2 rounded-full xs:text-xs sm:text-sm">
                                        Choose file
                                    </button>
                                </div>
                            </div>

                            <div className="mt-2">
                                {files.length !== 0
                                    ? <p className="text-white xs:text-xxs sm:text-base">Your File: {files}</p>
                                    : fileRejections.length !== 0 &&
                                    <p className="text-red-500 dark:text-red-400 xs:text-xxs sm:text-base">{fileRejections[0]?.errors[0]?.message}</p>
                                }
                            </div>
                        </div>


                        <p className="xs:text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2">We recommend an image of at least 300x300. Gifs work too. Max 5mb.</p>


                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg mt-6 md:mt-10">Profile Banner</h4>

                        <div className="xs:mt-4 md:mt-8">
                            <div {...getRootProps({ className: 'profileBannerDropzone' })}>
                                <input {...getInputProps()} />
                                <div className="profle_banner_upload_file_box py-10 p-3 mt-3 rounded-xl text-center">
                                    {files2.length !== 0
                                        ? <p className="text-white xs:text-xxs sm:text-base mb-2">Your File: {files2}</p>
                                        : fileRejections.length !== 0 &&
                                        <p className="text-red-500 dark:text-red-400 xs:text-xxs sm:text-base mb-2">{fileRejections[0]?.errors[0]?.message}</p>

                                    }
                                    <button
                                        className="font-semibold dark:font-medium bg-cusBrightLink dark:bg-black text-cusLightLink dark:text-cusLink xs:px-4 sm:px-6 xs:py-1 sm:py-3 rounded-full xs:text-xs sm:text-sm">
                                        Choose file
                                    </button>
                                </div>
                            </div>
                        </div>
                        <p className="xs:text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-6">We recommend an image of at least 300x300. Gifs work too. Max 5mb.</p>
                    </div>
                </div>

            </div>



        </div >
    );
}
